const alphaIcon = require('./logos/alpha.svg')
const autoConfigGif = require('./others/auto-config.gif')
const avatar = require('./others/avatar.png')
const chatBubble = require('./icons/chat_bubble.svg')
const configuredThreadIcon = require('./logos/configuredThread.svg')
const cubeIcon = require('./icons/cube.svg')
const dfmAnnotationsGif = require('./logos/DFM_Gif_Annotation.gif')
const optimizationsGif = require('./logos/optimization_animation.gif')
const imDfmAnnotationsGif = require('./logos/im-dfm-annotations.gif')
const externalLink = require('./icons/external_link.svg')
const fabricateIcon = require('./logos/fabricate.svg')
const facebookLogo = require('./logos/facebook_logo.svg')
const fictivAnalytics = require('./icons/fictiv_analytics.svg')
const fictivAnalyticsFeedback = require('./icons/analytics_feedback_graphic.svg')
const fictivCircle = require('./logos/fictiv_circle.svg')
const fictivIcon = require('./logos/fictiv.png')
const fictivIconBlack = require('./logos/fictiv_black.svg')
const fictivIconGreen = require('./logos/fictiv_green.svg')
const fictivOrders = require('./icons/fictiv_orders.svg')
const fictivTeams = require('./icons/fictiv_teams.png')
const fictors = require('./others/Fictors.png')
const fordLogo = require('./logos/ford_logo.svg')
const historyIcon = require('./logos/history.svg')
const honeywellLogo = require('./logos/honeywell_logo.png')
const imUploadIcon = require('./icons/im_quote_upload_icons.svg')
const ideoLogo = require('./logos/ideo_logo.svg')
const intuitiveLogo = require('./logos/intuitive_logo.png')
const inventoryIcon = require('./logos/inventory.svg')
const jobsIcon = require('./logos/jobs.svg')
const lyftLogo = require('./logos/lyft_logo.svg')
const lockIcon = require('./logos/lock.svg')
const medtronicLogo = require('./logos/medtronic-logo.png')
const noOrdersIcon = require('./icons/no-orders.svg')
const partnersIcon = require('./icons/partners.svg')
const partsIcon = require('./icons/parts.svg')
const pdfIcon = require('./icons/pdf.svg')
const quotesIcon = require('./logos/quotes.svg')
const quipLogo = require('./logos/quip_logo.svg')
const reconIcon = require('./logos/reconciliation.svg')
const signupIframeBackground = require('./others/signup-iframe-background.png')
const sldprtIcon = require('./icons/sldprt.svg')
const soc2 = require('./logos/soc2.svg')
const stripeIcon = require('./logos/stripe.svg')
const stepIcon = require('./icons/step.svg')
const stlIcon = require('./icons/stl.svg')
const threeDViewerPolygon = require('./viewer/threeDViewerPolygon.svg')
const threadIcon = require('./logos/thread.svg')
const uploadIcon = require('./icons/upload_icons.svg')
const uploadIconWithoutPdf = require('./icons/upload_icon_without_pdf.svg')
const x_tIcon = require('./icons/x_t.svg')
const fictivLogo = require('./others/fictiv-logo.svg')
const errorIcon = require('./others/403.png')
const searchResultIcon = require('./icons/search_result.svg')
const nonpremiumUpsellSidebarImg = require('./logos/PremiumUpsellSidebarImage.png')
const ltoImg = require('./logos/Lead_Time_Optimizer.png')
const preferredPricingImg = require('./logos/Preferred_Pricing.png')
const businessAccountImg = require('./logos/Business_Account.png')
const teamWorkspaceImg = require('./logos/Team_Workspaces.png')
const premiumTagImg = require('./logos/Diamond_Premium.svg')
const premiumHeaderImg = require('./logos/Premium_Header_IMG.png')
const checkMark = require('./icons/check_mark.svg')
const information = require('./icons/Information.svg')
const barLoaderWithCheckbox = require('./icons/bar_loader_with_checkbox.svg')
const punchoutRequestCable = require('./icons/punchout_request_cable.svg')
const truckOutlinedImg = require('./logos/Truck_Outlined.svg')

export default {
    alphaIcon,
    avatar,
    autoConfigGif,
    chatBubble,
    configuredThreadIcon,
    cubeIcon,
    dfmAnnotationsGif,
    errorIcon,
    externalLink,
    imDfmAnnotationsGif,
    fabricateIcon,
    facebookLogo,
    fictivAnalytics,
    fictivAnalyticsFeedback,
    fictivCircle,
    fictivIcon,
    fictivIconBlack,
    fictivIconGreen,
    fictivOrders,
    fictivTeams,
    fictivLogo,
    fictors,
    fordLogo,
    historyIcon,
    honeywellLogo,
    ideoLogo,
    imUploadIcon,
    inventoryIcon,
    intuitiveLogo,
    jobsIcon,
    lockIcon,
    lyftLogo,
    medtronicLogo,
    noOrdersIcon,
    partnersIcon,
    partsIcon,
    pdfIcon,
    punchoutRequestCable,
    quipLogo,
    quotesIcon,
    reconIcon,
    signupIframeBackground,
    sldprtIcon,
    soc2,
    stepIcon,
    stlIcon,
    stripeIcon,
    threadIcon,
    threeDViewerPolygon,
    uploadIcon,
    uploadIconWithoutPdf,
    x_tIcon,
    searchResultIcon,
    optimizationsGif,
    nonpremiumUpsellSidebarImg,
    ltoImg,
    preferredPricingImg,
    businessAccountImg,
    teamWorkspaceImg,
    premiumTagImg,
    premiumHeaderImg,
    checkMark,
    information,
    barLoaderWithCheckbox,
    truckOutlinedImg,
}
